import TRANSLATION_ACCESSIBILITY_EN_GB from './accessibility/translation';
import TRANSLATION_BOOKING_EN_GB from './booking/translation';
import TRANSLATION_EVENTS_EN_GB from './events/translation';
import TRANSLATION_EXPERIENCES_EN_GB from './experiences/translation';
import TRANSLATION_FORM_EN_GB from './form/translation';
import TRANSLATION_LANDING_PAGES_EN_GB from './landingPages/translation';
import TRANSLATION_RESERVE_EN_GB from './reserve/translation';
import TRANSLATION_SIGNIN_EN_GB from './signin/translation';
import TRANSLATION_DATES_EN_GB from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_EN_GB,
  ...TRANSLATION_BOOKING_EN_GB,
  ...TRANSLATION_DATES_EN_GB,
  ...TRANSLATION_EVENTS_EN_GB,
  ...TRANSLATION_EXPERIENCES_EN_GB,
  ...TRANSLATION_FORM_EN_GB,
  ...TRANSLATION_LANDING_PAGES_EN_GB,
  ...TRANSLATION_RESERVE_EN_GB,
  ...TRANSLATION_SIGNIN_EN_GB,
};
